export default "__VITE_ASSET__CB9rNo56__"